/* eslint-disable no-unused-vars */
export enum Languages {
    EN = 'en',
    ZH = 'zh-Hans',
    JA = 'ja',
    KO = 'ko',
    CS = 'cs',
    DA = 'da',
    NL = 'nl',
    GB = 'en-GB',
    MX = 'es-MX',
    ES = 'es-ES',
    FR = 'fr',
    DE = 'de',
    EL = 'el',
    IT = 'it',
    TW = 'zh-Hant',
    PL = 'pl',
    PT = 'pt-PT',
    SV = 'sv'
}
/* eslint-enable no-unused-vars */

export const LanguageCultureMap: Record<string, string> = {
  'en': 'en-US',
  'zh-Hans': 'zh-CN',
  'ja': 'ja-JP',
  'ko': 'ko-KR',
  'cs': 'cs-CZ',
  'da': 'da-DK',
  'nl': 'nl-NL',
  'en-GB': 'en-GB',
  'es-MX': 'es-MX',
  'es-ES': 'es-ES',
  'fr': 'fr-FR',
  'de': 'de-DE',
  'el': 'el-GR',
  'it': 'it-IT',
  'zh-Hant': 'zh-TW',
  'pl': 'pl-PL',
  'pt-PT': 'pt-PT',
  'sv': 'sv-SE'
};